class storyCommitment {
  constructor (){
    this.$t = document.querySelector('.story-commitment');
    this.$content = this.$t.querySelector('.story-commitment-content');
    this.$blocks = this.$t.querySelectorAll('.story-commitment-block');
    this.lastScrollTop = window.scrollY || document.documentElement.scrollTop;
    this.currentScroll = 0;


    this.$blocks[0].classList.add('is-active');

    this._scroll();
    window.addEventListener('scroll', () => {
      this._scroll();
      this.lastScrollTop = this.currentScroll <= 0 ? 0 : this.currentScroll;
    });
  }
  _scroll = () => {
    this.currentScroll = window.scrollY || document.documentElement.scrollTop;
    let isUpDown = this.currentScroll > this.lastScrollTop ? 'down' : 'up';
    let wh = SiteValues.wh();
    let t = this.$content.getBoundingClientRect().top * -1;

    if (t > 0) {
      this.$blocks.forEach(($block, index) => {
        let $bg = $block.querySelector('.story-commitment-block__bg');
        let $prev = this.$blocks[index - 1];
        let $next = this.$blocks[index + 1];
        let from = wh * index;
        let to = wh * (index + 1);
        if (t > from && t < to) {
          $block.classList.add('is-active');
          $block.classList.remove('is-active-prev');
          $block.classList.remove('is-active-next');
          this.$blocks.forEach(($otherBlock, otherIndex) => {
            if (index != otherIndex) {
              $otherBlock.classList.remove('is-active');
            }
          });
          if ($prev && isUpDown === 'down') {
            $prev.classList.add('is-active-prev');
            $prev.classList.remove('is-active');
          }
          if ($next && isUpDown === 'up') {
            $next.classList.add('is-active-next');
            $next.classList.remove('is-active');
          }
        }
      });
    }
  };
};

const $storyCommitment = document.querySelector('.story-commitment');
if($storyCommitment) new storyCommitment();

